import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ClubWorkItemsListRequest } from '@/features/work/api/club-work-items-list/request';
import { clubWorkItemsList } from '@/features/work/api/club-work-items-list/request';

export const useClubWorkItemsListQuery = (
  params: ClubWorkItemsListRequest,
  settings?: QuerySettings<typeof clubWorkItemsList>
) =>
  useQuery({
    queryKey: ['ClubWorkItemsList', params.profileId, params.status],
    queryFn: () =>
      clubWorkItemsList({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
